import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { createInquiry } from '../api/client';

export default function InquiryPage() {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  if (!auth) {
    window.location.replace('/login');
    return null;
  }

  const handleSubmit = async () => {
    if (!subject || !body) {
      setError('件名と本文は必須です');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await createInquiry({ vendorCompanyCode: auth.vendorCompanyCode, subject, body });
      setSuccess(true);
    } catch (e: any) {
      setError(e.response?.data?.message ?? 'エラーが発生しました');
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={{ color: '#276749' }}>お問い合わせを送信しました</h2>
          <p style={{ color: '#718096', lineHeight: 1.7 }}>
            内容を確認の上、担当者よりご連絡いたします。
          </p>
          <button style={styles.button} onClick={() => navigate('/invoice')}>
            請求書登録に戻る
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1 style={styles.title}>お問い合わせ</h1>
          <button style={styles.logoutBtn} onClick={logout}>ログアウト</button>
        </div>
        <p style={styles.info}>{auth.email} でログイン中</p>

        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>件名 *</label>
          <input
            style={styles.input}
            value={subject}
            onChange={e => setSubject(e.target.value)}
            maxLength={200}
            placeholder="お問い合わせ件名"
          />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={styles.label}>本文 *</label>
          <textarea
            style={{ ...styles.input, minHeight: 160, resize: 'vertical' }}
            value={body}
            onChange={e => setBody(e.target.value)}
            placeholder="お問い合わせ内容をご記入ください"
          />
        </div>

        {error && <p style={styles.error}>{error}</p>}
        <button style={styles.button} onClick={handleSubmit} disabled={submitting}>
          {submitting ? '送信中...' : '送信する'}
        </button>

        <div style={styles.linkSection}>
          <span style={{ color: '#718096', fontSize: 14 }}>担当者が変わりましたか？</span>
          <button style={styles.linkBtn} onClick={() => navigate('/change-contact')}>
            担当者変更はこちら
          </button>
        </div>

        <button style={styles.backBtn} onClick={() => navigate('/invoice')}>
          請求書登録に戻る
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { minHeight: '100vh', background: '#f0f4f8', padding: '24px 16px' },
  card: { background: '#fff', borderRadius: 12, padding: 28, maxWidth: 640, margin: '0 auto', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' },
  title: { margin: 0, fontSize: 20, color: '#1a365d' },
  info: { background: '#ebf8ff', borderRadius: 6, padding: '8px 12px', fontSize: 13, color: '#2c5282', marginBottom: 16 },
  label: { display: 'block', fontWeight: 600, marginBottom: 4, fontSize: 13, color: '#4a5568' },
  input: { width: '100%', padding: '8px 10px', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' as const },
  button: { width: '100%', padding: 14, background: '#2b6cb0', color: '#fff', border: 'none', borderRadius: 6, fontSize: 16, cursor: 'pointer', fontWeight: 600, marginTop: 8 },
  logoutBtn: { padding: '6px 14px', background: '#fff', color: '#718096', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 13, cursor: 'pointer' },
  error: { color: '#e53e3e', fontSize: 14, marginTop: 8 },
  linkSection: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 20, paddingTop: 16, borderTop: '1px solid #e2e8f0' },
  linkBtn: { background: 'none', border: 'none', color: '#2b6cb0', fontSize: 14, cursor: 'pointer', textDecoration: 'underline', padding: 0 },
  backBtn: { width: '100%', marginTop: 10, padding: 10, background: 'none', color: '#718096', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 14, cursor: 'pointer' },
};
